import {Button} from 'platform/components';
import {Box, Heading, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {ErrorImage} from './ErrorImage';

interface ImportErrorProps {
  onClose: () => void;
}

export function ImportError(props: ImportErrorProps) {
  return (
    <Box padding={6}>
      <VStack align="center" justify="center" spacing={4}>
        <ErrorImage />
        <Heading size={2}>{i18n.t('entity.import.labels.importErrorHeading')}</Heading>
        <Box maxWidth={165}>
          <Text align="center" color="secondary">
            {i18n.t('entity.import.labels.importErrorDescription')}
          </Text>
        </Box>
        <Button title={i18n.t('entity.import.labels.tryAgain')} onClick={props.onClose} />
      </VStack>
    </Box>
  );
}
